'use client';

import { Book, UserProfile } from 'types';
import ProductPageSellerInfo from '@/components/product/seller-info';

interface ProductSellerClientProps {
  sellerData?: UserProfile;
  bookData?: Book;
}
export default function ProductSellerClient({ sellerData, bookData }: ProductSellerClientProps) {
  if (!sellerData || !bookData) return null;

  return <ProductPageSellerInfo seller={sellerData} book={bookData} style='small' />;
}